import { parseCookies } from '@cian/utils';
import { setCookie } from '@cian/utils/lib/browser/cookie';

export const setUserCookieIfAgent = (isAgent: boolean) => {
  if (!isAgent) {
    return;
  }

  const cookies = parseCookies(document.cookie);
  if (cookies['userLoginAsAgent'] === '1') {
    return;
  }

  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);

  setCookie('userLoginAsAgent', '1', {
    expires: date,
    secure: false,
    domain: '.cian.ru',
  });
};



// WEBPACK FOOTER //
// ./src/bundles/header/components/set_user_agent_cookie/index.ts